import "./services.css";
import VaccinesRoundedIcon from "@mui/icons-material/VaccinesRounded";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import blumeImg from "../../assets/img/petker-blume-1.svg";

const Services = () => {
	return (
		<section className="services">
			<img className="blume-img" src={blumeImg} alt="blume" />
			<div className="container">
				<div className="text-zone">
					<span className="sub-title">Unsere Leistungen</span>
					<h2 className="title">Pflege mit Herz und Hand</h2>
					<p className="desc">
						Pflege ist mehr als unser Beruf, sie ist eine Herzensangelegenheit.
						Wir unterstützen Sie gerne mit unseren Leistungen, damit Sie Ihre
						Lebensqualität zu Hause, in der Tagespflege oder in unserer
						Wohngruppe beibehalten und erleben dürfen. Glückliche, lustige aber
						auch traurige Momente werden geteilt und verbinden uns.
					</p>
				</div>
				<div className="cards">
					<div className="two">
						<div className="card">
							<i className="icon t-3">
								<VaccinesRoundedIcon />
							</i>
							<h3 className="title">Mobile Pflege</h3>
							<p className="desc">
								Wir sind Ihr ständiger Begleiter in der Pflege und für Sie
								mobil.
							</p>
						</div>
						<div className="card">
							<i className="icon t-3">
								<MedicalServicesOutlinedIcon />
							</i>
							<h3 className="title">Tagespflege</h3>
							<p className="desc">
								Gemeinsame Tage von Früh bis Spät in guter Gesellschaft.
							</p>
						</div>
					</div>
					<div className="card">
						<i className="icon t-3">
							<GroupAddOutlinedIcon />
						</i>
						<h3 className="title">Wohngruppe</h3>
						<p className="desc">
							Genießen Sie ein würdevolles Leben in sozialer Gemeinschaft.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Services;
